/**
 * Created by Bart Decorte
 * Date: 14/09/2021
 * Time: 10:15
 */
import UploadPreviewSingle from './UploadPreviewSingle';

export default class UploadPreviewImage extends UploadPreviewSingle {
  constructor(rootEl, params = {}) {
    super(rootEl, params);
    this.miniatureBoxWidth = 1000;
    this.miniatureBoxHeight = 120;
  }

  async renderMiniature() {
    const dataUrl = await this.miniatureSource();
    this.miniatureEl().style.backgroundImage = `url('${dataUrl}')`;
  }

  renderMiniatureAlt() {
    this.miniatureEl().title = this.file.name;
  }

  renderFilename() {

  }

  filenameEl() {

  }

  storedUrl() {
    return this.miniatureEl().dataset.storedUrl;
  }

  hasStoredUrl() {
    return this.storedUrl() > '';
  }

  hasStoredData() {
    return this.hasStoredUrl();
  }

  clear() {
    super.clear();
    this.restore(this.storedUrl());
  }

  restore(url) {
    this.miniatureEl().style.backgroundImage = typeof url === typeof undefined ? 'none' : `url('${url}')`;
  }

  miniatureEl() {
    return this.rootEl.querySelector('.js-preview-image');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewImage.js